export default __webpack_public_path__ + "static/media/PawPlus.309e37c2.svg";